var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 8.5v15L15.75 31 3 23.5v-15L15.75 1 28.5 8.5zm-13.152 8.11-1.185.7 2.214 1.294 1.177-.694 3.15 1.852-4.698 2.76-9.742-5.68-.04 2.766 9.789 5.684 9.404-5.53-5.51-3.243 1.11-.657-2.215-1.292-1.102.652-1.545-.91 1.351-.8-2.214-1.293-1.345.793-2.63-1.547 4.694-2.762 6.493 3.793 2.38-1.406-8.876-5.157L6.6 11.465l4.995 2.94-.942.554 2.214 1.293.935-.552 1.546.91z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIost);
export default __webpack_public_path__ + "static/media/IOST.d9f0f5f8384caeb7ce5823ac28a7775f.svg";
export { ForwardRef as ReactComponent };